import { mediaData } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Dramatic%20dark%20themed%20entertainment%20news%20visual%20with%20abstract%20spotlight%20effect%2C%20warm%20crimson%20and%20charcoal%20tones%2C%20cinematic%20composition%20with%20mysterious%20atmosphere%2C%20editorial%20style%20with%20dramatic%20lighting%20and%20deep%20shadows%2C%20gossip%20media%20aesthetic&width=800&height=450&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dark%20moody%20visual%20with%20abstract%20geometric%20patterns%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20lighting%20with%20soft%20glow%20effects%2C%20entertainment%20news%20broadcast%20aesthetic%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20professional%20editorial%20photography%20style&width=800&height=450&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20intersecting%20light%20beams%20in%20warm%20gold%20and%20crimson%20hues%2C%20dark%20background%20with%20textured%20overlay%2C%20cinematic%20mystery%20theme%2C%20editorial%20spotlight%20effect%2C%20professional%20media%20production%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape'
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">视频专区</h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">热门人物事件视频深度解读</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="px-2.5 py-1 text-xs bg-background-900/80 text-foreground-200 rounded-md whitespace-nowrap">{item.duration}</span>
                  <span className="text-xs text-foreground-400">{item.views} 次播放</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-primary-400 transition-colors">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}